import React, { type ReactNode } from "react";
import type { VideoServerInterface } from "../video-server/video-server-interface";

const VideoServerContext = React.createContext<VideoServerInterface | null>(null);

interface VideoServerProviderProps {
  videoServer: VideoServerInterface;
  children: ReactNode;
}

export const VideoServerProvider = ({ videoServer, children }: VideoServerProviderProps) => {
  const [initializedVideoServer] = React.useState<VideoServerInterface | null>(videoServer);
  return <VideoServerContext.Provider value={initializedVideoServer}>{children}</VideoServerContext.Provider>;
};

export const useVideoServerContext = () => React.useContext(VideoServerContext)!;
